import { Route } from '@angular/router';
import { DeviceSelectionComponent } from '@features/activity-types/assign-device/device-selection/device-selection.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const assign_device_routes: Route[] = [
  {
    path: 'device-selection',
    component: DeviceSelectionComponent,
    title: 'Select Device',
    data: { order_type_id: 9 }
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 9 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 9 }
  },
  {
    path: '',
    redirectTo: 'device-selection',
    pathMatch: 'full'
  }
];
